// extracted by mini-css-extract-plugin
module.exports = {"toptitle":"research-module--toptitle--ScNNg","items":"research-module--items--wHbg3","item":"research-module--item--1AidM"};